// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "offer_package".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "offer_package" table (1:1 with a DB row, on the wire). */
export const offerPackageAtomSchema = z.object({
    id: z.string(),
    offerId: z.string(),
    packageId: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=offerPackage.js.map